import { ItemSerie } from './item-serie.model';
import { NTECH_API } from './../app.api';
import { Injectable } from '@angular/core';
import { Http, Headers, RequestOptions } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import { ErrorHandler } from './../app.error-handler';

@Injectable()
export class ItemSerieService {

    constructor(private http: Http) {
    }

    getItensSerie(): Observable<ItemSerie[]> {
        return this.http.get(`${NTECH_API}/item-serie`)
        .map(response => response.json())
        .catch(ErrorHandler.handleError);
    }
}



// WEBPACK FOOTER //
// ./src/app/item-serie/item-serie.service.ts